import { Breadcrumb,Button,Select,Space,Form,Modal,Input,Popconfirm,message, Spin } from "antd"
import {Link} from "react-router-dom"
import { DashboardOutlined,DeleteOutlined,EditOutlined,PlusSquareOutlined  } from "@ant-design/icons"
import {useState,useRef, useContext,useEffect} from "react";
import {BsBuilding} from "react-icons/bs";
import {FaBookReader} from "react-icons/fa";
import DataTable from "../../components/common/table";
import UploadButton from "../../components/common/uploadButton";
import Header from "../../components/dashboard/header";
import { useCreateDepartment, useDeleteDepartment, useDepartments, useUpdateDepartment } from "../../hooks/department/departmentQuery";
import { extractValueFromInputRef,scrollToTop } from "../../helpers/dom";
import RefreshContext from "../../context/refreshContext";


const {Option} = Select;




const departmentTableColumns = [
    {
        title:"S/N",
        key:"s/n",
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Name",
        dataIndex:"title",
        key:"name"
    },
    {
        title:"Code",
        dataIndex:"value",
        key:"name"
    },
    {
        title:"Actions",
        key:"actions",
        render: (_,department)=>(
            <DepartmentEdit department={department}/>
        )
    }
]



function DepartmentEdit({department}){
    const [isEditOpen,setIsEditOpen] = useState(false);
    const showEditModal = ()=> setIsEditOpen(true);
    const hideEditModal = ()=> setIsEditOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);

    const deleteDepartment = useDeleteDepartment();
    const updateDepartment = useUpdateDepartment();

    const valueRef = useRef(null);
    const titleRef = useRef(null);
    const officeTitleRef = useRef(null)

    const confirmDeleteDepartment = async()=>{
        const {message:response} = await deleteDepartment(department.id);
        message.success(response??"department deleted sucessfully")
        setFlag(!flag);
    }


    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            value:extractValueFromInputRef(valueRef),
            officeTitle:extractValueFromInputRef(officeTitleRef)
        };
        const {message:response} = await updateDepartment(department.id,payload);
        message.success(response??"department updates successfully");
        setIsEditOpen(false);
        setFlag(!flag);
    }


return(
    <>
        <Space size="small" wrap>
            <Button type="primary" onClick={showEditModal}>
            <EditOutlined />
                Edit
            </Button>
            <Popconfirm
                 title="Delete this department"
                 description="Are you sure to delete this department?"
                 onConfirm={confirmDeleteDepartment}
                onCancel={()=>null}
                okText="Yes"
                cancelText="No"
                 >
                <Button type="primary" danger>
                    <DeleteOutlined />
                    Delete
                </Button>
            </Popconfirm>
        </Space>
        <Modal title={"Update Department Data"} open={isEditOpen} footer={null} onCancel={hideEditModal}>
            <div style={{marginTop:"3em"}}>

                        <Form

                              wrapperCol={{
                                span: 24,
                              }} initialValues={{...department}}>
                                <Form.Item
                          name="title"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input department title!',
                                    },
                                  ]}>
                            <Input size="large" ref={titleRef} placeholder="Title"/>
                          </Form.Item>
                          <Form.Item
                          name="value"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input department name!',
                                    },
                                  ]}>
                            <Input size="large" ref={valueRef} placeholder="Code"/>
                          </Form.Item>
                            <Form.Item
                                name="officeTitle"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input office title!',
                                    },
                                ]}>
                                <Input size="large" ref={officeTitleRef} placeholder="Office title"/>
                            </Form.Item>

                          <Form.Item
                              wrapperCol={{
                                span:8,
                                offset:16
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Update Department
                              </Button>
                            </Form.Item>
                        </Form>
            </div>
        </Modal>
    </>
)
}




export default function Department(){
    const [isOpen,setIsOpen] = useState(false);
    const showCreateModal = ()=>setIsOpen(true);
    const hideCreateModal = ()=>setIsOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);


    const nameRef = useRef(null);
    const titleRef = useRef(null);
    const officeTitleRef = useRef(null);

    const createDepartment = useCreateDepartment();


    useEffect(()=>{
        scrollToTop();
    },[]);


    const {loading,departments} = useDepartments(flag);


    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            value:extractValueFromInputRef(nameRef),
            officeTitle: extractValueFromInputRef(officeTitleRef)
        }
        const {message:response} = await createDepartment(payload);
        message.success(response ?? "department added successfully");
        setIsOpen(false);
        setFlag(!flag);
    }

    return(
        <>
             <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                        <DashboardOutlined className="dashboard-icon"/>
                        <Link to={"/dashboard"}>Dashboard</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                        <BsBuilding/>
                        <Link to={"/dashboard"}>Office</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <FaBookReader/>
                            <Link to="/dashboard/user">Department</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                            <PlusSquareOutlined />
                                Add Department
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                        <DataTable cols={departmentTableColumns} data={departments}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Add Department" open={isOpen} footer={null} onCancel={hideCreateModal}>
            <div style={{marginTop:"3em"}}>
                        <Form
                              wrapperCol={{
                                span: 24,
                              }}>
                            <Form.Item
                          name="title"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input department title!',
                                    },
                                  ]}>
                            <Input size="large" placeholder="Title" ref={titleRef}/>
                          </Form.Item>
                          <Form.Item
                          name="name"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input department name!',
                                    },
                                  ]}>
                            <Input size="large" placeholder="Code" ref={nameRef}/>
                          </Form.Item>
                            <Form.Item
                                name="officeTitle"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input office title!',
                                    },
                                ]}>
                                <Input size="large" ref={officeTitleRef} placeholder="Office title"/>
                            </Form.Item>
                          <Form.Item
                              wrapperCol={{
                                span:8,
                                offset:16
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Add Department
                              </Button>
                            </Form.Item>
                        </Form>
            </div>
            </Modal>
        </>
    )
}

